module.exports = __webpack_public_path__ + "static/media/users.c811872d.svg";